if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const newActive = event.detail.currentElement;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${newActive.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.announceLiveRegion(newActive, thumbnail?.dataset.mediaPosition);
        this.playActiveMedia(newActive);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        this.playActiveMedia(activeMedia);

        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
        this.announceLiveRegion(activeMedia, thumbnail?.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('button').forEach((el) => el.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => this.elements.liveRegion.setAttribute('aria-hidden', true), 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(item) {
        const videos = document.querySelectorAll('video.lazy-video');
        videos.forEach((v) => {
          if (v !== item.querySelector('video')) {
            v.pause();
            v.closest('.video-container')?.querySelector('.play-overlay')?.classList.remove('hidden');
          }
        });

        const video = item.querySelector('video');
        if (video && video.dataset.userPaused !== 'true') {
          video.play().catch(err => console.log('Autoplay blocked:', err));
          video.closest('.video-container')?.querySelector('.play-overlay')?.classList.add('hidden');
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        this.stickyHeader?.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        this.elements.viewer.slider?.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems?.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".lazy-video");
  videos.forEach((video, index) => {
    const container = video.closest(".video-container");
    const overlay = container?.querySelector(".play-overlay");

    if (index !== 0) {
      video.pause();
      video.removeAttribute("autoplay");
      video.dataset.userPaused = "true";
      overlay?.classList.remove("hidden");
    } else {
      video.dataset.userPaused = "false";
    }

    video.addEventListener("click", () => {
      if (video.paused) {
        video.dataset.userPaused = "false";
        video.play().catch(e => console.log("Autoplay blocked:", e));
        overlay?.classList.add("hidden");
      } else {
        video.dataset.userPaused = "true";
        video.pause();
        overlay?.classList.remove("hidden");
      }
    });

    overlay?.addEventListener("click", (e) => {
      e.stopPropagation();
      video.dataset.userPaused = "false";
      video.play().catch(e => console.log("Autoplay blocked:", e));
      overlay.classList.add("hidden");
    });

    video.addEventListener("play", () => {
      videos.forEach((v) => {
        if (v !== video) {
          v.pause();
          v.dataset.userPaused = "false";
          v.closest(".video-container")?.querySelector(".play-overlay")?.classList.remove("hidden");
        }
      });
    });

    video.addEventListener("timeupdate", () => {
      if (video.currentTime >= video.duration - 0.1 && video.dataset.userPaused !== "true") {
        video.currentTime = 0;
        video.play();
      }
    });
  });
});

let mobileObserverInitialized = false;

function initMobileSwipeAutoplay() {
  if (window.innerWidth >= 750 || mobileObserverInitialized) return;

  const slides = document.querySelectorAll('[data-media-id]');
  const root = document.querySelector('[id^="GalleryViewer"]');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      const video = target.querySelector("video.lazy-video");
      const overlay = target.querySelector(".play-overlay");

      if (!video) return;

      if (isIntersecting && video.dataset.userPaused !== "true") {
        document.querySelectorAll("video.lazy-video").forEach((v) => {
          if (v !== video) v.pause();
        });
        video.play().catch(e => console.log("Autoplay blocked:", e));
        overlay?.classList.add("hidden");
      } else {
        video.pause();
        if (video.dataset.userPaused !== "true") overlay?.classList.remove("hidden");
      }
    });
  }, { root, threshold: 0.6 });

  slides.forEach(slide => observer.observe(slide));
  mobileObserverInitialized = true;
}

document.addEventListener("DOMContentLoaded", initMobileSwipeAutoplay);
window.addEventListener("resize", initMobileSwipeAutoplay);

let lastIsMobile = window.innerWidth < 750;

window.addEventListener('resize', () => {
  const isNowMobile = window.innerWidth < 750;

  if (!isNowMobile && lastIsMobile) {
    // We just transitioned from mobile → desktop
    const gallery = document.querySelector('media-gallery');
    const firstSlide = document.querySelector('[data-media-id]');
    if (gallery && firstSlide && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(firstSlide.dataset.mediaId, false);
    }
  }

  lastIsMobile = isNowMobile;
});